import { render } from "./AnserView.vue?vue&type=template&id=6d25bc24&scoped=true"
import script from "./AnserView.vue?vue&type=script&lang=js"
export * from "./AnserView.vue?vue&type=script&lang=js"

import "./AnserView.vue?vue&type=style&index=0&id=6d25bc24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d25bc24"]])

export default __exports__